import {
    useState,
    useCallback
} from 'react';
import {
    Container,
    Content,
    Time
} from './styled';
import VisibilitySensor from 'react-visibility-sensor';
import { PiStickerFill } from "react-icons/pi";
import { getImage } from '../../../../service/serviceChat/chatService';

export function Sticker(props) {


    const { message, className } = props;
    const [url, setUrl] = useState('');

    const searchUrl = useCallback(async (message) => {
        const { url } = await getImage(message?.id_sticker)
        if (url)
            setUrl(url);
        return
    }, []);
    const onSearchUrl = (isVisible) => {
        if (!isVisible || url) return;
        searchUrl(message);
    };

    function getTimeFromMessage(message) {
        const timeString = message?.date?.split(" ")[1];
        if (!timeString) return null;
        const [hh, mm] = timeString.split(":");
        const time = `${hh}:${mm}`;
        return time;
    }

    return (

        <Container
            className={className}
            isUserSystem={(message?.user_system) ? 1 : 0}
        >
            {(!url)
                ? <VisibilitySensor
                    onChange={
                        (isVisible) => { onSearchUrl(isVisible) }
                    }
                >
                    <div className='skeleton--box'>
                        <span className='skeleton'></span>
                        <PiStickerFill className='icon--' />
                    </div>
                </VisibilitySensor>
                : <Content>
                    <img
                        src={url}
                    />
                </Content>
            }
            <Time>
                <span>
                    {getTimeFromMessage(message)}
                </span>
            </Time>
        </Container>
    )
}